import styled from 'styled-components'

const Wrapper = styled.nav`
  height: var(--nav-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 1px 0px 0px rgba(0, 0, 0, 0.1);
  padding: 1%;

  .heading{
      width: 100%;
      height: 100%;
      justify-content: center;
      display: flex;
      align-items: center;
  }

  .logo {
    display: flex;
    align-items: center;
    width: 180px;
  }
  .nav-center {
    display: flex;
    align-items: center;
  }
  .toggle-btn {
    background: transparent;
    border-color: transparent;
    font-size: 1.75rem;
    color: var(--primary-500);
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  background: var(--white);
  .btn-container {
    position: relative;
  }
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0 0.5rem;
    position: relative;
    box-shadow: var(--shadow-2);
  }

  .dropdown {
    position: absolute;
    top: 40px;
    left: 0px;
    right: 0px;
    background: var(--primary-100);
    box-shadow: var(--shadow-2);
    padding: 0.5rem;
    text-align: center;
    visibility: hidden;
    border-radius: var(--borderRadius);
  }

  .dropdown: hover {
    background: var(--primary-500);
  }

  .show-dropdown {
    visibility: visible;
  }
  .dropdown-btn {
    width: 100%;
    height: 100%;
    background: transparent;
    border-color: transparent;
    color: var(--primary-500);
    letter-spacing: var(--letterSpacing);
    
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0 0.5rem;
  }

  .dropdown-btn: hover {
    color: var(--white);
  }

  .logo-text {
    display: none;
    margin: 0;
  }

  //@media (min-width: 992px) {
    @media (min-width: 1120px){
    position: sticky;
    top: 0;
    z-index: 999;

    .toggle-btn{
      display: none;
    }

    .btn{

      width: max-content;
    }

    .logo {
      display: none;
    }
    .logo-text {
      display: block;
    }
    
  }
`
export default Wrapper
